var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.698242 46.9662C0.698242 21.0275 21.7257 0 47.6644 0C73.6031 0 94.6305 21.0275 94.6305 46.9662V49.0338C94.6305 74.9725 73.6031 96 47.6644 96C21.7257 96 0.698242 74.9725 0.698242 49.0338V46.9662Z",
    fill: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6982 54.5C60.0607 54.5 69.2697 45.2111 69.2697 33.75C69.2697 22.2889 60.0607 13 48.6982 13C37.3357 13 28.1268 22.2889 28.1268 33.75C28.1268 45.2111 37.3357 54.5 48.6982 54.5ZM63.0982 59.6875H60.4143C56.8465 61.341 52.8768 62.2812 48.6982 62.2812C44.5197 62.2812 40.5661 61.341 36.9822 59.6875H34.2982C22.3732 59.6875 12.6982 69.4465 12.6982 81.475V88.2188C12.6982 92.5146 16.1536 96 20.4125 96H76.984C81.2429 96 84.6982 92.5146 84.6982 88.2188V81.475C84.6982 69.4465 75.0232 59.6875 63.0982 59.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_9247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 83,
    fill: "white",
    transform: "translate(12.6982 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.d09f2c58f9c145cf613edbf7c8662997.svg";
export { ForwardRef as ReactComponent };